<template>
  <div class="event-page fixed-nav">
    <MainHeader
      :dark="false"
      :fixedMenu="true"
      :loginButton="false"
      :tiles="false"
      @logoClick="logoClick">
      <svg>
        <use v-if="selectedTranslation === 'en'" xlink:href="#logoFmkSvgEng"></use>
        <use v-else xlink:href="#logoFmkSvg"></use>
      </svg>
    </MainHeader>
    <div class="sections">
      <section class="section-main" v-if="contentData">

        <div class="back-btn-bar">
          <button type="button"
                  class="back-btn"
                  @click.stop="logoClick(true)">
            <svg height="14" width="24"><use xlink:href="#arrowBackSvg"></use></svg>
          </button>
        </div>

        <div class="container container-small text-center">
          <h2 class="text-xl underline accent text-left">
            {{ contentData.header }}
          </h2>

          <div class="event-page-content text-left">
            <p class="text-m paragraph" v-html="contentData.content"></p>
          </div>

        </div>

        <div class="page-container" v-if="contentData.gallery.length">
          <SwipeHandler @swipeLeft="swipeLeft" @swipeRight="swipeRight">
              <div class="slider dark bg-dark">
                <div class="slide-wrapper">
                  <figure class="slide"
                  :class="{
                      'slide-prev': index === (activeItem - 1 + contentData.gallery.length) % contentData.gallery.length,
                      'slide-active': index === activeItem,
                      'slide-next': index === (activeItem + 1) % contentData.gallery.length
                    }"
                    v-for="(item, index) in contentData.gallery" :key="'img-' + index">
                    <div class="slide-img">
                      <img :src="item.url" :alt="item.alt" />
                    </div>

                    <figcaption class="slide-counter text-right" v-if="contentData.gallery.length > 1">
                      {{(index + 1)}}/{{contentData.gallery.length}}
                    </figcaption>
                  </figure>
                </div>
                <SliderControllers
                  class="controllers"
                   v-if="contentData.gallery.length > 1"
                  @showPrev="showPrev"
                  @showNext="showNext"
                  :hideMobile="false"
                  :small="true"
                  :displayNext="sliderDisplayNext"
                  :displayPrev="sliderDisplayPrev" />
              </div>
            </SwipeHandler>
        </div>

        <div class="container container-small text-center">

          <div class="event-page-content text-left" v-if="contentData.additionalContant">
            <p class="text-m paragraph" v-html="contentData.additionalContant"></p>
          </div>

          <EventPageNav :pageNav="pageNav" routeName="wydarzenia" />
        </div>

      </section>
      <section v-else class="section-main container-expand container-expand-404 bg-light2">
        <div class="container container-small">
          <AccentHeader
            :header="errorData.pageNotFound.header + '<br/>' + errorData.pageNotFound.code"
            :underline="true"
            :uppercase="false"
          />
          <div class="error-404">
            {{ errorData.pageNotFound.description }}
          </div>
        </div>
      </section>
      <MainFooter :content="footerData" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import MainHeader from '@/components/MainHeader.vue'
import MainFooter from '@/components/MainFooter.vue'
import AccentHeader from '@/components/AccentHeader.vue'
import SliderControllers from '@/components/SliderControllers.vue'
import SwipeHandler from '@/components/SwipeHandler.vue'
import EventPageNav from '@/components/EventPageNav.vue'

export default {
  name: 'EventPage',
  components: {
    MainHeader,
    MainFooter,
    AccentHeader,
    SliderControllers,
    SwipeHandler,
    EventPageNav
  },
  data () {
    return {
      contentData: {
        header: '',
        content: '',
        additionalContant: '',
        gallery: []
      },
      pageNav: {
        prev: {
          id: null,
          title: '',
          details: ''
        },
        next: {
          id: null,
          title: '',
          details: ''
        }
      },
      currentEvent: 0,
      activeItem: 0,
      sliderDisplayNext: false,
      sliderDisplayPrev: false
    }
  },
  computed: {
    ...mapGetters([
      'museumData',
      'footerData',
      'buttonData',
      'errorData',
      'selectedTranslation',
      'dataLoaded'
    ])
  },
  methods: {
    swipeRight () {
      this.showPrev()
    },
    swipeLeft () {
      this.showNext()
    },
    showNext () {
      if (this.activeItem + 1 < this.contentData.gallery.length) {
        this.activeItem = Math.min(this.activeItem + 1, this.contentData.gallery.length - 1)
      } else {
        this.activeItem = 0
      }
      this.sliderItems()
    },
    showPrev () {
      if (this.activeItem - 1 >= 0) {
        this.activeItem = Math.max(this.activeItem - 1, 0)
      } else {
        this.activeItem = this.contentData.gallery.length - 1
      }
      this.sliderItems()
    },
    sliderItems () {
      if (this.activeItem === 0) {
        this.sliderDisplayPrev = false
        this.sliderDisplayNext = true
      } else if (this.activeItem === this.contentData.gallery.length - 1) {
        this.sliderDisplayPrev = true
        this.sliderDisplayNext = false
      } else {
        this.sliderDisplayPrev = true
        this.sliderDisplayNext = true
      }
    },
    logoClick (back) {
      if (back) {
        this.$router.push({ 'name': 'foundation', 'hash': '#wydarzenia' })
      } else {
        this.$router.push({ 'name': 'foundation' })
      }
    },
    getContentData (eventID) {
      if (!this.museumData.events.items) { return false }

      this.museumData.events.items.map((item, index) => {
        if (item.id === parseInt(eventID)) {
          this.currentEvent = index
          this.contentData = {
            header: item.header,
            content: (item.content1 ? item.content1 : item.description).replace(/(?:\r\n|\r|\n)/g, '</p><p class="text-m paragraph">'),
            additionalContant: (item.content2 ? item.content2.replace(/(?:\r\n|\r|\n)/g, '</p><p class="text-m paragraph">') : null),
            gallery: item.gallery
          }
          return false
        }
      })
      this.activeItem = 0
      this.sliderItems()
      this.setPageNav()
    },
    setPageNav () {
      if (!this.museumData.events.items) { return false }
      const pages = this.museumData.events.items
      let pagePrev = (this.currentEvent >= 1 ? pages[(this.currentEvent - 1)] : pages[(pages.length - 1)])
      let pageNext = (this.currentEvent < (pages.length - 1) ? pages[(this.currentEvent + 1)] : pages[0])

      this.pageNav = {
        prev: {
          id: (pagePrev ? pagePrev.id : null),
          title: (pagePrev ? pagePrev.header : null),
          details: (pagePrev && pagePrev.subheader ? pagePrev.subheader : null)
        },
        next: {
          id: (pageNext ? pageNext.id : null),
          title: (pageNext ? pageNext.header : null),
          details: (pageNext && pageNext.subheader ? pageNext.subheader : null)
        }
      } // END this.pageNav;
    }
  },
  watch: {
    dataLoaded (newVal, oldVal) {
      if (newVal) {
        this.getContentData(this.$route.params.id)
      }
    }
  },
  mounted () {
    this.getContentData(this.$route.params.id)
  },
  beforeRouteUpdate (to, from, next) {
    this.getContentData(to.params.id)
    next()
  }
}
</script>

<style scoped lang="scss">
.event-page {

  .section-main {
    min-height: 400px;
  }

  &-content {
    margin: 0 auto;
    padding: $gap-md 0;
    width: 100%;
    max-width: 700px;
  } // END .event-page-content;

  @include screen ('sm') {

    .container-small,
    .back-btn-bar {
      padding: 0;
      width: calc(100% - #{($gap-md * 2)});
      max-width: 88%;
    }
  }

  @include screen ('md') {

    .section-main {
      min-height: 50vh;
    }

    .container-small,
    .back-btn-bar {
      width: 88vw;
      max-width: $container-content-max-width; // calc(90vw - 286px);
    }
  }

  .slider {
    margin: $gap-md 0;
    overflow: hidden;
    padding: 0;
    position: relative;

    @include screen('sm') {
      margin: $gap-lg 0;
    }

    .slide {
      bottom: 0;
      display: none;
      left: 0;
      margin: 0;
      height: 100%;
      padding: 0;
      position: absolute;
      text-align: center;
      transition: $transitionSlider;
      width: 100%;
      z-index: 1;

      img {
        height: auto;
        margin: 0 auto;
        width: 100%;
        // max-width: $container-content-max-width;

        @include screen('sm') {
          height: 100%;
          width: auto;
        }
      }

      &-wrapper {
        height: 0;
        padding-bottom: 52%;
        position: relative;
        width: 100%;
      } // END .slide-wrapper;

      &-img {
        height: 100%;
        overflow: hidden;
        position: relative;
        width: 100%;
      } // END .slide-img;
      &-prev,
      &-next,
      &-active {
        display: block;
      }

      &-prev {
        transform: translateX(-100vw);
        opacity: 0;
      }
      &-next {
        transform: translateX(100vw);
        opacity: 0;
        transition: $transitionSlider;
      }
      &-active {
        transform: translateX(0);
        opacity: 1;
      }

      &-counter {
        bottom: 0;
        font: {
          size: $font-xs;
          weight: 700;
        }
        padding: 0 $gap-md $gap-sm;
        position: absolute;
        text-shadow: 0 2px 2px rgba($text-dark, 0.35);
        width: 100%;

        @include screen ('md') {
          padding-bottom: ceil($gap-sm * 1.5);
        }
      } // END .slide-counter;

    } // END .slide;

    .controllers {
      left: 1%;
      position: absolute;
      top: 50%;
      width: 98%;
      z-index: 10;

      /deep/ svg {
        filter: drop-shadow(0 2px 2px rgba($text-dark, 0.35));
      }
    }

  } // END .slider;
} // END .event-page;
</style>
